import type { ElementType } from "react";
import RefreshSelectedSurveysModal from "@components/modals/RefreshSelectedSurveysModal";
import ImportSelectedSurveysModal from "@components/modals/ImportSelectedSurveysModal";
import DuplicateSurveysModal from "@components/modals/DuplicateSurveysModal";
import SurveysUpdateListModal from "@components/modals/SurveysUpdateListModal";
import CreateDatasetModal from "@components/modals/CreateDatasetModal";
import DatasetRenameModal from "@components/modals/DatasetRenameModal";
import SelectDatasetForSurveysModal from "@components/modals/SelectDatasetForSurveysModal";
import NoAvailableSurveysModal from "@components/modals/NoAvailableSurveysModal";
import NoDatasetsAvailableModal from "@components/modals/NoDatasetsAvailableModal";
import ArchiveDashboardModal from "@components/modals/ArchiveDashboardModal";
import TabManagementModal from "@components/modals/TabManagementModal";
import CreateDashboardModal from "@components/modals/CreateDashboardModal";
import DuplicatedDashboardNameModal from "@components/modals/DuplicatedDashboardNameModal";
import DeleteWidgetConfirmationModal from "@components/modals/DeleteWidgetConfirmationModal";
import EditDashboardModal from "@/components/modals/EditDashboardModal";
import CreateChartModal from "@/components/modals/CreateChartModal";
import PublishDashboardModal from "@/components/modals/PublishDashboardModal";
import ShareDashboardModal from "@/components/modals/ShareDashboardModal";
import UnpublishDashboardModal from "@/components/modals/UnpublishDashboardModal";
import DiscardConfigurationChangesModal from "@/components/modals/DiscardConfigurationChangesModal";
import ConfigureCadenceModal from "@/components/modals/ConfigureCadenceModal";
import ClearAvailabilityDateModal from "@/components/modals/ClearAvailabilityDateModal";
import GuardrailCompatibilityModal from "@/components/modals/GuardrailCompatibilityModal";

export type ModalProps = {
  closeAction: () => void;
  cancelAction: () => void;
  [key: string]: unknown;
};

export interface IModal {
  isOpen: boolean;
  modalType: IModalType;
  props: ModalProps;
}
export interface IModalState {
  modals: IModal[];
}

export enum MODALS {
  IMPORT_SELECTED_SURVEYS_MODAL = "IMPORT_SELECTED_SURVEYS_MODAL",
  REFRESH_SELECTED_SURVEYS_MODAL = "REFRESH_SELECTED_SURVEYS_MODAL",
  DUPLICATE_SURVEYS_MODAL = "DUPLICATE_SURVEYS_MODAL",
  SURVEYS_UPDATE_LIST_MODAL = "SURVEYS_UPDATE_LIST_MODAL",
  CREATE_DATASET_MODAL = "CREATE_DATASET_MODAL",
  DATASET_RENAME_MODAL = "DATASET_RENAME_MODAL",
  SELECT_DATASET_FOR_SURVEYS_MODAL = "SELECT_DATASET_FOR_SURVEYS_MODAL",
  NO_AVAILABLE_SURVEYS_MODAL = "NO_AVAILABLE_SURVEYS_MODAL",
  NO_DATASETS_AVAILABLE_MODAL = "NO_DATASETS_AVAILABLE_MODAL",
  ARCHIVE_DASHBOARD_MODAL = "ARCHIVE_DASHBOARD_MODAL",
  TAB_MANAGEMENT_MODAL = "TAB_MANAGEMENT_MODAL",
  CREATE_DASHBOARD_MODAL = "CREATE_DASHBOARD_MODAL",
  DUPLICATED_DASHBOARD_NAME_MODAL = "DUPLICATED_DASHBOARD_NAME_MODAL",
  DELETE_WIDGET_CONFIRMATION_MODAL = "DELETE_WIDGET_CONFIRMATION_MODAL",
  EDIT_DASHBOARD_MODAL = "EDIT_DASHBOARD_MODAL",
  CREATE_CHART_MODAL = "CREATE_CHART_MODAL",
  PUBLISH_DASHBOARD_MODAL = "PUBLISH_DASHBOARD_MODAL",
  UNPUBLISH_DASHBOARD_MODAL = "UNPUBLISH_DASHBOARD_MODAL",
  SHARE_DASHBOARD_MODAL = "SHARE_DASHBOARD_MODAL",
  DISCARD_CONFIGURATION_CHANGES_MODAL = "DISCARD_CONFIGURATION_CHANGES_MODAL",
  CONFIGURE_CADENCE_MODAL = "CONFIGURE_CADENCE_MODAL",
  CLEAR_AVAILABILITY_DATE_MODAL = "CLEAR_AVAILABILITY_DATE_MODAL",
  GUARDRAIL_COMPATIBILITY_MODAL = "GUARDRAIL_COMPATIBILITY_MODAL",
}
export type IModalType = MODALS | null;

export type ModalList = Record<MODALS, ElementType>;

export const modalList: ModalList = {
  [MODALS.IMPORT_SELECTED_SURVEYS_MODAL]: ImportSelectedSurveysModal,
  [MODALS.REFRESH_SELECTED_SURVEYS_MODAL]: RefreshSelectedSurveysModal,
  [MODALS.DUPLICATE_SURVEYS_MODAL]: DuplicateSurveysModal,
  [MODALS.SURVEYS_UPDATE_LIST_MODAL]: SurveysUpdateListModal,
  [MODALS.CREATE_DATASET_MODAL]: CreateDatasetModal,
  [MODALS.DATASET_RENAME_MODAL]: DatasetRenameModal,
  [MODALS.SELECT_DATASET_FOR_SURVEYS_MODAL]: SelectDatasetForSurveysModal,
  [MODALS.NO_AVAILABLE_SURVEYS_MODAL]: NoAvailableSurveysModal,
  [MODALS.NO_DATASETS_AVAILABLE_MODAL]: NoDatasetsAvailableModal,
  [MODALS.ARCHIVE_DASHBOARD_MODAL]: ArchiveDashboardModal,
  [MODALS.TAB_MANAGEMENT_MODAL]: TabManagementModal,
  [MODALS.CREATE_DASHBOARD_MODAL]: CreateDashboardModal,
  [MODALS.DUPLICATED_DASHBOARD_NAME_MODAL]: DuplicatedDashboardNameModal,
  [MODALS.DELETE_WIDGET_CONFIRMATION_MODAL]: DeleteWidgetConfirmationModal,
  [MODALS.EDIT_DASHBOARD_MODAL]: EditDashboardModal,
  [MODALS.CREATE_CHART_MODAL]: CreateChartModal,
  [MODALS.PUBLISH_DASHBOARD_MODAL]: PublishDashboardModal,
  [MODALS.UNPUBLISH_DASHBOARD_MODAL]: UnpublishDashboardModal,
  [MODALS.SHARE_DASHBOARD_MODAL]: ShareDashboardModal,
  [MODALS.DISCARD_CONFIGURATION_CHANGES_MODAL]:
    DiscardConfigurationChangesModal,
  [MODALS.CONFIGURE_CADENCE_MODAL]: ConfigureCadenceModal,
  [MODALS.CLEAR_AVAILABILITY_DATE_MODAL]: ClearAvailabilityDateModal,
  [MODALS.GUARDRAIL_COMPATIBILITY_MODAL]: GuardrailCompatibilityModal,
};
